import { io } from "socket.io-client";
import { getRouteManager } from "./services/routeManager";

const SOCKET_URL = getRouteManager().getSocketUrl();

export const socket = io(SOCKET_URL, {
    autoConnect: false,
});
